<template>
  <div class="lyf-ui-badge">
    <div class="lyf-ui-badge-dot"
      :class="{ 
        small: origin === 'center', 
        border, 
        content: badgeContent,
        single: singleContent
      }" 
      :style="{
        backgroundColor: color
      }">{{ badgeContent }}</div>
    <slot></slot>
  </div>
</template>

<script>
import publicVar from '@/assets/style/var.module.css'

export default {
  name: 'LyfBadge',
  props: {
    color: {
      type: String,
      default: publicVar._F1_2
    },
    border: {
      type: Boolean,
      default: false
    },
    origin: {
      type: String,
      default: 'right-top'
    },
    content: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    singleContent() {
      let flag = false
      if (this.badgeContent && this.badgeContent.length === 1) {
        flag = true
      }
      return flag
    },
    badgeContent() {
      return this.content > 0 
              ? this.content > 99 ? '99+' : this.content
              : ''
    }
  }
}
</script>

<style scoped>
.lyf-ui-badge {
  position: relative; 
  display: inline-block;
}
.lyf-ui-badge .lyf-ui-badge-dot {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.lyf-ui-badge .lyf-ui-badge-dot.small {
  top: -5px;
  right: -5px;
}
.lyf-ui-badge .lyf-ui-badge-dot.border {
  box-sizing: border-box;
  border: solid var(--border-width_1) var(--N3_1);
}
.lyf-ui-badge .lyf-ui-badge-dot.content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 14px;
  padding: 0 5px;
  border-radius: 14px;
  border: solid var(--border-width_1) var(--N3_1);
  color: var(--font-color_4);
  font-size: var(--font-size_1);
  line-height: 1;
}
.lyf-ui-badge .lyf-ui-badge-dot.single {
  width: 14px;
  padding: 0;
}
</style>